(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('mailExplorerDao', ["http", "$rootScope", function (http, $rootScope) {
        return {
            searchEmails: function (params) {
                return http.post('/api/v1/mail_explorer/email_list').body(params);
            },
            searchEmails2: function (params) {
                return http.post('/api/v1/ap_avanan/exception_search2').body(params);
            },
            searchEmails2WithES: function (body) {
                var params = {};
                if ($rootScope.me2EsScrollId) {
                    params = { scroll_id: $rootScope.me2EsScrollId };
                } else {
                    params = {
                        size: 50,
                        scroll_ttl: '1m'
                    };
                }
                return http.post('/api/v1/mail_explorer2/emails').params(params).body(body);
            },
            quarantineAllMatch: function (body) {
                return http.post('/api/v1/mail_explorer2/emails/quarantine').body(body);
            }
        };
    }]);
}());